export function selectedText(value: string[]) {
  return value.join('、');
}
